// extracted by mini-css-extract-plugin
export default {"carousel-dots":"styles_carousel-dots__JXtHJ","carousel-dot":"styles_carousel-dot__-AX6R","carousel-dot-active":"styles_carousel-dot-active__oThJl"};